import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import { api, setToken } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      const res = await api.post("/admin/login", { email, password });
      setToken(res.data.token);
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grain bg-cream flex flex-col">
      <header className="px-6 lg:px-10 h-16 flex items-center border-b border-ink/10">
        <Logo />
      </header>
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-[440px] card-paper rounded-2xl p-8 lg:p-10">
          <div className="w-12 h-12 rounded-xl bg-rust/12 text-rust flex items-center justify-center mb-6">
            <Lock size={20} />
          </div>
          <div className="mono text-xs uppercase tracking-[0.2em] text-mute">Operator console</div>
          <h1 className="display text-4xl mt-3">
            Sign in to <span className="display-italic text-rust">AI Automate Systems</span>.
          </h1>
          <p className="text-ink/70 mt-3 text-sm">Lead pipeline, audit reports, performance.</p>

          <form onSubmit={submit} className="mt-8 space-y-6" data-testid="admin-login-form">
            <label className="block">
              <span className="form-label">Email</span>
              <input
                type="email"
                required
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                data-testid="admin-login-email"
              />
            </label>
            <label className="block">
              <span className="form-label">Password</span>
              <input
                type="password"
                required
                className="form-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="admin-login-password"
              />
            </label>
            <button
              type="submit"
              disabled={busy}
              className="btn-primary w-full px-5 py-3.5 rounded-full text-sm font-medium tracking-wide inline-flex items-center justify-center gap-2 disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              {busy ? <><Loader2 size={16} className="animate-spin" /> Signing in…</> : "Sign in"}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
